export class RemoveViqeo {
  constructor(options = {}) {
    this.options = {
      mobileBreakpoint: 960,
      debug: false,
      viqeoClasses: ['viqeo-embed', 'viqeo-flyWidget'],
      ...options
    };

    this.observer = null;
    this.initialized = false;

    this.init();
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    this.checkAndRemove();

    this.setupObserver();
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  isMobile() {
    return window.innerWidth < this.options.mobileBreakpoint;
  }

  isViqeoElement(element) {
    if (!element || !element.classList) return false;

    // Проверяем фиксированное позиционирование
    const isFixedPosition = window.getComputedStyle(element).position === 'fixed';
    if (!isFixedPosition) return false;

    // Проверяем наличие классов Viqeo у самого элемента или его потомков
    const hasViqeoClass = this.options.viqeoClasses.some(className => {
      return element.classList.contains(className) || 
             element.querySelector(`.${className}`) !== null;
    });

    return hasViqeoClass;
  }

  findViqeoContainer(element) {
    // Поднимаемся вверх по DOM, чтобы найти фиксированный контейнер
    let current = element;
    while (current !== document.body) {
      if (window.getComputedStyle(current).position === 'fixed') {
        return current;
      }
      current = current.parentElement;
    }
    return null;
  }

  removeElement(element) {
    if (!element) return false;
    
    element.remove();
    if (this.options.debug) {
      console.log('[RemoveViqeo] Viqeo widget removed:', element);
    }
    return true;
  }

  checkAndRemove() {
    if (!this.isMobile()) return false;

    // Ищем элементы с классами Viqeo
    const selectors = this.options.viqeoClasses.map(c => `.${c}`).join(', ');
    const viqeoElements = document.querySelectorAll(selectors);

    for (const element of viqeoElements) {
      const container = this.findViqeoContainer(element);
      if (container) {
        return this.removeElement(container);
      }
    }

    // Дополнительная проверка фиксированных элементов
    const fixedElements = document.querySelectorAll('[style*="position: fixed"]');
    for (const element of fixedElements) {
      if (this.isViqeoElement(element)) {
        return this.removeElement(element);
      }
    }

    return false;
  }

  setupObserver() {
    this.observer = new MutationObserver((mutations) => {
      if (!this.isMobile()) return;

      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            // Проверяем сам добавленный элемент
            if (this.isViqeoElement(node)) {
              this.removeElement(node);
              continue;
            }

            // Проверяем его потомков на наличие элементов Viqeo
            const viqeoChildren = this.options.viqeoClasses.some(className => {
              return node.querySelector(`.${className}`) !== null;
            });

            if (viqeoChildren) {
              const container = this.findViqeoContainer(node);
              if (container) {
                this.removeElement(container);
              }
            }
          }
        }
      }
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  handleResize() {
    if (this.isMobile()) {
      this.checkAndRemove();
    }
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    window.removeEventListener('resize', this.handleResize);
    this.initialized = false;
  }
}